import styled from '@emotion/styled';

import { MAX_DESKTOP_WIDTH_REM } from '../constants';

export const VMApplicationContentContainer = styled.div({
  display: 'flex', // Allow child components to fill the remaining space created by this component
  flexDirection: 'column',
  flexGrow: 1, // Fill the remaining space so the footer is forced to the bottom of the page
  maxWidth: MAX_DESKTOP_WIDTH_REM,
  margin: '0 auto',
  width: '100%',
});
